import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { TenantContainerModel } from '../../../../../models/aggregates/tenant';

//  https://api.akaun.cloud/core2/tnt/dm/tenants/login-tenant-ep


@Injectable({
  providedIn: 'root'
})

export class TenantLoginEPService extends BaseApiTemplateService<TenantContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'tenants/login-tenant-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'tenants/login-tenant-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'tenants/login-tenant-ep';
    this.httpClient = http;
  }

}